﻿import { Coordinate } from 'ol/coordinate';
import Geometry from 'ol/geom/Geometry';
import Point from 'ol/geom/Point';
import LinearRing from 'ol/geom/LinearRing';
import Polygon from 'ol/geom/Polygon';

import { BaseGeometryExtension, GeometryExtensionUtilities } from './BaseGeometryExtension';

export class LinearRingExtension extends BaseGeometryExtension<LinearRing> {

    public getCoordinates() {
        return this.geometry.getCoordinates();
    }

    public setCoordinates(coordinates: Coordinate[]): void {
        this.geometry.setCoordinates(coordinates);
    }

    public intersectsExtent(extent: [number, number, number, number]) {
        return this.geometry.intersectsExtent(extent);
    }

    public getMultiGeometry() {
        return new Polygon([this.geometry.getCoordinates()]);
    }    

    public insertGeometry(geometry: Geometry, path: number[]): number[] | undefined {
        const coords = this.getCoordinates() ?? [];

        if (geometry instanceof Point) {
            const position = GeometryExtensionUtilities.getPositionFromPath1(path);
            this.setCoordinates(GeometryExtensionUtilities.modifyPointInLine(position, coords, geometry.getCoordinates()));
            return position;
        }
        return undefined
    }

    public replaceGeometry(geometry: Geometry, path: number[]): number[] | undefined {
        const coords = this.getCoordinates() ?? [];

        if (geometry instanceof LinearRing) {
            this.setCoordinates(geometry.getCoordinates().slice())
            return [];
        }        
        else if (geometry instanceof Point) {
            const position = GeometryExtensionUtilities.getPositionFromPath1(path);
            const newCoords = GeometryExtensionUtilities.modifyPointInLine(position, coords, geometry.getCoordinates(), true);
            const [point] = position;
            GeometryExtensionUtilities.fixLinearRing(newCoords, point === 0 ? 'first' : 'last');
            this.setCoordinates(newCoords);
            return position;
        }

        return undefined
    }

    public removeGeometry(path: number[]): number[] | undefined {
        const coords = this.getCoordinates() ?? [];
        if (path.length >= 1 && coords[path[0]]) {
            const position = GeometryExtensionUtilities.getPositionFromPath1(path);
            this.setCoordinates(GeometryExtensionUtilities.modifyPointInLine(position, coords));
            return position;
        }

        return undefined;
    }

    public canRemove(path: number[]): boolean {
        const coords = this.getCoordinates() ?? [];

        if (path.length >= 1) {
            const line = coords[path[0]];
            if (line) {
                // remove line
                if (path.length === 1)
                    return coords.length > 1;
                // remove point
                else
                    return line.length > 4 && !!line[path[1]];
            }
        }

        return false;
    }

    public groupSectionsAtDateLine() {
      
    }

    public mergeSnappedPoints() {        
        const coords = this.getCoordinates();
        if (coords.length > 2) {
            const merged = GeometryExtensionUtilities.mergeSnappedPoints(coords);
            if (merged) {
                this.setCoordinates(merged);
                return true;
            }
        }
        return false;
    }
}
